import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { BsModalRef } from 'ngx-bootstrap/modal'

import { SolicitacaoOperadora } from '../../../pkw-data/collect/solicitacao-operadora.model'
import { SolicitacaoOperadoraService } from '../solicitacao-operadora.service'

@Component({
    selector: 'col-solicitacao-operadora-modal',
    templateUrl: './solicitacao-operadora-modal.component.html',
    styles: ['.modal-body { padding-bottom: 0;}'],
})
export class SolicitacaoOperadoraModalComponent implements OnInit {
    @Input() solicitacaoOperadora: SolicitacaoOperadora = null

    @Input()
    @Output()
    salvo = new EventEmitter<SolicitacaoOperadora>()

    @ViewChild(NgForm) form: NgForm

    nomeOperadoraMaxlength: number
    linkOperadoraMaxlength: number
    nomeLabel: string
    nomePlaceholder: string
    nomeMaxlength: number
    telefoneLabel: string
    telefonePlaceholder: string
    telefoneMaxlength: number
    emailLabel: string
    emailPlaceholder: string
    emailMaxlength: number
    observacoesAdicionaisMaxlength: number
    usuarioNumerico: string
    usuarioDeveSerEmail: string

    enviandoDados: boolean
    errorMessages = ERROR_MESSAGES

    constructor(
        private bsModalRef: BsModalRef,
        private solicitacaoOperadoraService: SolicitacaoOperadoraService,
    ) { }

    ngOnInit() {
        this.enviandoDados = false

        this.nomeOperadoraMaxlength = 100
        this.linkOperadoraMaxlength = 100
        this.nomeLabel = "Nome"
        this.nomePlaceholder = "Informe o nome"
        this.nomeMaxlength = 100
        this.telefoneLabel = "Telefone"
        this.telefonePlaceholder = "Informe o telefone"
        this.telefoneMaxlength = 11
        this.emailLabel = "Email"
        this.emailPlaceholder = "Informe o email"
        this.emailMaxlength = 100

        this.observacoesAdicionaisMaxlength = 350

        this.initNovo()
    }

    clickSalvar() {
        if (this.form.valid) {
            this.atualizarDados(this.solicitacaoOperadora)
            this.salvarSolicitacaoOperadora()
        }
    }

    salvarSolicitacaoOperadora() {
        this.enviandoDados = true
        this.solicitacaoOperadoraService.salvar(this.solicitacaoOperadora).subscribe(() => {
            this.salvo.emit(this.solicitacaoOperadora)
            this.fechar()
        })
    }

    fechar() {
        this.bsModalRef.hide()
    }

    private initNovo() {
        this.solicitacaoOperadora = this.solicitacaoOperadoraService.novo()

        setTimeout(() => this.preencherForm(this.solicitacaoOperadora))
    }

    private preencherForm(solicitacaoOperadora: SolicitacaoOperadora) {
        this.form.reset({
            nomeOperadora: solicitacaoOperadora.nomeOperadora,
            linkSiteOperadora: solicitacaoOperadora.linkSiteOperadora,
            nomeUsuario: solicitacaoOperadora.nomeUsuario,
            telefoneUsuario: solicitacaoOperadora.telefoneUsuario,
            emailUsuario: solicitacaoOperadora.emailUsuario,
            observacoesUsuario: solicitacaoOperadora.observacoesUsuario
        })
    }

    private atualizarDados(solicitacaoOperadora: SolicitacaoOperadora) {
        const valores = this.form.value

        solicitacaoOperadora.nomeOperadora = valores.nomeOperadora
        solicitacaoOperadora.linkSiteOperadora = valores.linkSiteOperadora
        solicitacaoOperadora.nomeUsuario = valores.nomeUsuario
        solicitacaoOperadora.telefoneUsuario = valores.telefoneUsuario
        solicitacaoOperadora.emailUsuario = valores.emailUsuario
        solicitacaoOperadora.observacoesUsuario = valores.observacoesUsuario
    }

    naoPermitirEspacos(event) {
        return event.charCode !== 32
    }
}

const ERROR_MESSAGES = {
    required: 'Campo obrigatório',
    pattern: 'Apenas números.',
    equalsTo: 'Confirmação incorreta.',
    email: 'Insira um endereço de e-mail válido.',
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/solicitacao-operadora/solicitacao-operadora-modal/solicitacao-operadora-modal.component.ts